module.exports = __webpack_public_path__ + "img/COULD.cf4ff0da.png";